import { FC } from "react";
import Desktop from "../app/desktop/Desktop.component";

const DesktopPage: FC = () => <Desktop />;

export default DesktopPage;